import './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { s as send, z as addToCartAlternative, A as addToCartSubstitution, r as removeFromFavoritesEvent } from './send-33ade633.js';
import { i as isProductUpdated } from './utils-c23b708f.js';

const buildCTAClickEvent = (initialEvent, options) => {
  const { isCartTransferEnabled, inCart, id, quantity, onFinish, groupId, groupType, displayName } = options;
  const productCommonProps = {
    id,
    quantity,
  };
  const commonProps = {
    type: isCartTransferEnabled ? 'cart' : 'favorites',
    inList: isCartTransferEnabled ? false : inCart,
    initialEvent,
    onFinish,
  };
  if (groupId) {
    if (inCart && !isCartTransferEnabled) {
      return Object.assign(Object.assign({}, commonProps), { product: {
          id: groupId,
          repositoryId: groupId,
        } });
    }
    return Object.assign(Object.assign({}, commonProps), { product: Object.assign(Object.assign({}, productCommonProps), { groupId,
        groupType,
        displayName }) });
  }
  return Object.assign(Object.assign({}, commonProps), { product: Object.assign({}, productCommonProps) });
};
const getProducts = (response, productId, quantity) => {
  return Object.entries(response.infoForGa).map((entry) => {
    const [id, product] = entry;
    const { brand = '', description, price = null } = product;
    const isUpdated = isProductUpdated(id, response);
    return Object.assign({ brand,
      price,
      id, category: '', name: description, quantity: quantity[id] }, (isUpdated ? { variant: productId } : {}));
  });
};
const sendAnalytics = (response, productId, quantity, isAlternatives) => {
  var _a, _b;
  const { infoForGa } = response;
  const products = getProducts(response, productId, quantity);
  const currencyCode = (_b = (_a = Object.values(infoForGa).find((product) => product.currency)) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : '';
  if ('productsUpdated' in response) {
    send(isAlternatives ? addToCartAlternative : addToCartSubstitution, {
      currencyCode,
      products,
      distributor: '',
    });
  }
  else {
    send(removeFromFavoritesEvent, {
      currencyCode,
      products,
    });
  }
};

export { buildCTAClickEvent as b, sendAnalytics as s };
